import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { APIService } from 'api/module'
import { MediaPermissionsService } from 'media/services/mediaPermissions.service'
import { PanelService } from 'panel/services/panel.service'
import { MediaOperationsService } from '../services/mediaOperations.service'
import { BaseOperation } from './base'
import { NotifyService } from 'common/util/services/notify.service'

@Injectable({ providedIn: 'root' })
class CombineIntoSetOp extends BaseOperation {
  icon = 'far fa-box-open'
  showInSelectionToolbar = true
  showInContextMenu = true
  supportsMultiple = true
  supportsBundles = true
  weight = 65

  constructor (
    private translate: TranslateService,
    private panel: PanelService,
    private api: APIService,
    private mediaPermissions: MediaPermissionsService,
    private notify: NotifyService,
  ) {
    super()
    this.label = translate.instant('Combine into set')
  }

  isVisibleForBundle (bundle) {
    return bundle.mainfile && this.mediaPermissions.getPermissionForBundle(bundle)?.allowWriteDb
  }

  isVisibleFor ({ dirs, bundles }, context) {
    return bundles.filter(x => x.asset).length > 1 && !this.panel.active && super.isVisibleFor({ bundles, dirs }, context)
  }

  async run ({ bundles }) {
    const selected = bundles.filter(b => b.asset)

    try {
      await this.api.mediaLibrary.combineAssetsIntoSet({
        multipleAssetsRequest: {
          assets: selected.map(s => s.asset.id),
        },
      })
      this.notify.success(this.translate.instant('Assets added to set'))
    } catch (error) {
      this.notify.errorFromResponse(this.translate.instant('Could not add assets to set'), error)
    }
  }
}

MediaOperationsService.register(CombineIntoSetOp)
